enum ROUTES {
  ROOT = '/',

  //#region Authentication
  AUTHENTICATION = '/authentication',
  LOGOUT = '/logout',
  //#endregion

  //#region Analytics
  ANALYTICS_BETA = '/analytics/beta',
  //#endregion

  //#region Tournaments
  TOURNAMENT_BLIND_STRUCTURES = '/tournament/blind-structures',
  TOURNAMENT_TEMPLATES = '/tournament/templates',
  TOURNAMENTS_LIST = '/tournaments/list',
  TOURNAMENT_DETAILS = '/tournaments/details',
  TOURNAMENT_REGISTRATIONS = '/tournaments/registrations',
  TOURNAMENT_REBALANCE = '/tournaments/rebalance',
  TOURNAMENTS_OVERVIEW = '/tournaments/overview',
  TOURNAMENT_PAYOUT_STRUCTURES = '/tournament/payout-structures',
  TOURNAMENT_PAYOUT_STRUCTURE_DETAILS = '/tournament/payout-structures/details/:payoutStructureId',
  TOURNAMENT_PAYOUT_STRUCTURE_CREATE = '/tournament/payout-structures/create',
  SNG_OVERVIEW = '/sng/overview',
  SNG_LIST = '/sng/list',
  SNG_TEMPLATES = '/sng/templates',
  TOURNAMENT_SETTINGS = '/tournaments/settings',
  TOURNAMENT_SCHEDULES = '/tournaments/schedule',
  TOURNAMENT_TICKETS = '/tournaments/tickets',
  //#endregion

  //#region Tables
  TABLES = '/tables/list',
  TABLE = '/table/details',
  TABLE_EDIT = '/tables/edit',
  TABLE_SYNC = '/tables/sync',
  TABLE_ANALYTICS = '/tables/analytics',
  TABLE_HANDS = '/tables/hands',
  PARAMETERS_RAKE_STRUCTURE = '/structure/blinds',
  PARAMETERS_RAKE_STRUCTURE_CREATE = '/structure/blinds/create',
  PARAMETERS_RAKE_STRUCTURE_UPDATE = '/structure/blinds/update',
  PARAMETERS_GAME_CONFIGS_CREATE = '/structure/game-params/create',
  PARAMETERS_MIXED_GAMES_STRUCTURE = '/template/mixed-games',
  CONTRACT_SYNC = '/contract/sync',
  TEMPLATES = '/templates',
  TEMPLATE = '/template',
  TEMPLATE_CREATE = '/templates/create',
  //#endregion

  //#region Users
  USERS = '/users',
  USER = '/user/details',
  USER_EDIT = '/user/edit',
  USER_ANALYTICS = '/user/analytics',
  USER_DEALS = '/user/deals',
  PROP_PLAYERS = '/prop-players',
  AGREEMENTS = '/agreements',
  AGREEMENTS_CREATE = '/agreements/create',
  //#endregion

  //#region Agents
  AGENTS_ANALYTICS = '/agents/analytics',
  AGENTS = '/agents',
  AGENT_PROFILE = '/agents/:agentId',
  AGENTS_MIGRATIONS = '/agents/migrations',
  AGENTS_REFERRAL_DEPTH_FIX = '/agents/referral-depth-fix',
  AGENTS_REGIONS = '/agents/regions',
  AGENTS_COUNTRIES = '/agents/countries',
  AGENTS_AGENT_DEAL_UPDATE_REQUESTS = '/agents/agent-deal-update-requests',
  //#endregion

  //#region Reports
  REPORTS_SIGNUP = '/reports/signup',
  //#endregion

  //#region Rake
  RAKE_ANALYTICS = '/rake/analytics',
  RAKE_TABLE = '/rake/table',
  RAKE_PLAYER = '/rake/player',
  RAKE_SHARE = '/rake-share/payments',
  RAKE_SHARE_PER_PLAYER = '/rake-share/payments/player',
  RAKE_REWARDS = '/rake-rewards/payments',
  RAKE_REWARDS_PER_PLAYER = '/rake-rewards/payments/player',
  RAKE_BACK = '/rake-back/payments',
  RAKE_BACK_PER_PLAYER = '/rake-back/payments/player',
  //#endregion

  //#region Transactions
  TRANSACTIONS = '/transactions',
  //#endregion

  //#region Tokens
  TOKEN_FLOW_ORCHESTRATOR_WIZARD = '/token-flow-orchestrator/wizard',
  TOKENS_BALANCE = '/tokens/balance',
  CONTRACT_BALANCES = '/contract-balances',
  //#endregion

  //#region Leaderboard
  LEADERBOARD_PAYOUTS = '/leaderboard-payouts',
  LEADERBOARD_CONFIG = '/leaderboard/config',
  LEADERBOARD_SCHEDULE = '/leaderboard/schedule',
  //#endregion

  //#region Deposits
  DEPOSITS = '/deposits',
  DEPOSIT_DETAILS = '/deposits/:id',
  //#endregion

  //#region Wallets
  WALLET_TRANSFERS = '/wallet-transfers',
  BULK_TRANSFERS = '/bulk-transfers',
  //#endregion

  //#region Alerts
  ALERTS = '/alerts',
  //#endregion

  //#region Maintenance
  MAINTENANCE = '/maintenance',
  //#endregion

  DEV_TOOLS = '/dev-tools',
}

export default ROUTES;
